export default __webpack_public_path__ + "static/aws-12fbd8c22cd2ca73c9c6b9c636b829f6.svg";